export class DrawerModel {
	mode: 'over' | 'push' | 'side';
	opened: boolean;
	pinned: boolean;
}
